<template>
  <div class="password-requirements">
    <!-- Title (optional) -->
    <div v-if="showTitle">Password requirements:</div>

    <!-- Grid Layout -->
    <div v-if="useGridLayout" class="requirements-grid">
      <div class="column">
        <PasswordRequirementRow :isValid="hideStatuses ? null : hasMinLength">
          At least {{ passwordMinLength }} characters long
        </PasswordRequirementRow>
        <PasswordRequirementRow
          :isValid="hideStatuses ? null : hasUppercaseAndLowercase"
        >
          Includes both uppercase and lowercase letters
        </PasswordRequirementRow>
      </div>
      <div class="column">
        <PasswordRequirementRow :isValid="hideStatuses ? null : hasNumbers">
          Contains at least one number
        </PasswordRequirementRow>
        <PasswordRequirementRow
          :isValid="hideStatuses ? null : hasSpecialChars"
          className="special-character"
        >
          Contains at least one special character (e.g., !@#$%^&*)
        </PasswordRequirementRow>
      </div>
    </div>

    <!-- List Layout (default) -->
    <ul v-else>
      <PasswordRequirementRow :isValid="hideStatuses ? null : hasMinLength">
        At least {{ passwordMinLength }} characters long
      </PasswordRequirementRow>
      <PasswordRequirementRow
        :isValid="hideStatuses ? null : hasUppercaseAndLowercase"
      >
        Includes both uppercase and lowercase letters
      </PasswordRequirementRow>
      <PasswordRequirementRow :isValid="hideStatuses ? null : hasNumbers">
        Contains at least one number
      </PasswordRequirementRow>
      <PasswordRequirementRow
        :isValid="hideStatuses ? null : hasSpecialChars"
        className="special-character"
      >
        Contains at least one special character (e.g., !@#$%^&*)
      </PasswordRequirementRow>
    </ul>

    <slot name="additional-requirements"></slot>
  </div>
</template>

<script>
import { PASSWORD_MIN_LENGTH } from '@components/sign-up/validatePassword'
import PasswordRequirementRow from '@components/sign-up/PasswordRequirementRow.vue'

export default {
  name: 'PasswordRequirements',
  components: { PasswordRequirementRow },
  props: {
    hideStatuses: Boolean,
    hasMinLength: {
      type: [Boolean, null],
      default: null
    },
    hasUppercaseAndLowercase: {
      type: [Boolean, null],
      default: null
    },
    hasNumbers: {
      type: [Boolean, null],
      default: null
    },
    hasSpecialChars: {
      type: [Boolean, null],
      default: null
    },
    useGridLayout: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      passwordMinLength: PASSWORD_MIN_LENGTH
    }
  }
}
</script>

<style scoped lang="scss">
.password-requirements {
  font-size: 13px;
}

.requirements-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
}

.column {
  padding-right: 10px;
}

ul {
  padding-left: 0;
  font-weight: 400;
  list-style: none;
}

.special-character {
  width: 110%;
}
</style>
